module.exports = __webpack_public_path__ + "img/KW.240dcfca.svg";